import { TenantSubscription } from '../../entities/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum CrmSecurityRight {
    CanAccess = 300000,
    ManageServiceProviders = 300001,
    ManageCustomers = 300002,
    ManageSuppliers = 300003,
    ManageEmployees = 300004,
    ManageSubcontractors = 300005,
    ManageSecurityRoles = 300006,
    ManageCompanies = 300007,
    ManageUsersWithoutEmail = 300008,
    ManageSites = 300009,
    ViewRecurringJobsWithinCustomers = 300010,
    ViewServicesWithinSites = 300011,
    ViewRecurringJobsWithinSites = 300012,
}

export class CrmSecurityModule extends BaseSecurityModule<CrmSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Crm,
            [
                { _id: CrmSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: CrmSecurityRight.ManageServiceProviders, name: 'Manage Service Providers', basic: false },
                { _id: CrmSecurityRight.ManageCustomers, name: 'Manage Customers', basic: false },
                { _id: CrmSecurityRight.ManageSuppliers, name: 'Manage Suppliers', basic: false },
                { _id: CrmSecurityRight.ManageEmployees, name: 'Manage Employees', basic: false },
                { _id: CrmSecurityRight.ManageUsersWithoutEmail, name: 'Manage Users Without Email', basic: false },
                { _id: CrmSecurityRight.ManageSubcontractors, name: 'Manage Subcontractors', basic: false },
                { _id: CrmSecurityRight.ManageSecurityRoles, name: 'Manage Security Roles', basic: false },
                { _id: CrmSecurityRight.ManageCompanies, name: 'Manage Companies', basic: false },
                { _id: CrmSecurityRight.ManageSites, name: 'Manage Sites', basic: false },
                { _id: CrmSecurityRight.ViewRecurringJobsWithinCustomers, name: 'View Recurring Jobs within Customers', basic: false },
                { _id: CrmSecurityRight.ViewServicesWithinSites, name: 'View Services within Sites', basic: false },
                { _id: CrmSecurityRight.ViewRecurringJobsWithinSites, name: 'View Recurring Jobs within Sites', basic: false },

            ] as SecurityRight<CrmSecurityRight>[]
        );

        this.plan = TenantSubscription.System;
    }


}
